const loginTemplate = require('../../views/login.html').trim();

module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.authentication', {
            abstract: true
        })
        .state('shop.authentication.login', {
            url: '/secure-login',
            data: {
                analytics: `bws:web:secure-login`
            },
            views: {
                'center-panel@': {
                    controller: [
                        '$scope', '$state', function ($scope, $state) {
                            $scope.$on('login:success', function (event, loginResult, loginPrompt) {
                                if (!loginPrompt.willRedirect) {
                                    $state.go('shop.myaccount');
                                }
                            });
                        }
                    ],
                    template: '<wow-login-form></wow-login-form>'
                }
            },
            onExit: [
                'LoginService', function (loginService) {
                    // If the state was navigated to as a result of a prompt for login,
                    // we need to reject the promise for the prompt when we exit the login panel.
                    // If the login is successful, the promise should already have been resolved and
                    // this will do nothing.
                    loginService.rejectPromptForLogin();
                }
            ]
        })
        .state('shop.authentication.signup', {
            url: '/signup',
            data: {
                analytics: 'bws:web:signup'
            },
            params: {
                email: null
            },
            views: {
                'center-panel@': {
                    template: '<wow-signup-form class="signupPage-form"></wow-signup-form>'
                },
                'dynamic-content-top@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule class="dynamic-content2-panelTop"></oly-dynamic-content>'
                },
                'dynamic-content-bottom@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule="bottom" class="dynamic-content2-panelBottom"></oly-dynamic-content>'
                }
            }
        })
        // Reset password
        .state('shop.authentication.resetpassword', {
            url: '/reset-password?passwordResetToken',
            data: {
                analytics: 'bws:web:reset-password'
            },
            views: {
                'left-panel@': {
                    controller: [
                        '$stateParams', '$scope', 'BreakpointsService', function ($stateParams, $scope, breakpointsService) {
                            $scope.passwordResetToken = $stateParams.passwordResetToken;
                            $scope.breakpointsService = breakpointsService;
                        }
                    ],
                    template: '<wow-reset-password password-reset-token="{{::passwordResetToken}}" ng-if="breakpointsService.isSmallFormat()"></wow-reset-password>'
                },
                'center-panel@': {
                    controller: [
                        '$stateParams', '$scope', function ($stateParams, $scope) {
                            $scope.passwordResetToken = $stateParams.passwordResetToken;
                        }
                    ],
                    template: '<wow-reset-password password-reset-token="{{::passwordResetToken}}"></wow-reset-password>'
                }
            }
        })
        //Forget password
        .state('shop.authentication.forgotpassword', {
            url: '/forgot-password',
            data: {
                analytics: 'bws:web:forgot password'
            },
            params: {
                emailAddress: null
            },
            views: {
                'center-panel@': {
                    template: '<wow-login-password-reset></wow-login-password-reset>'
                }
            }
        })
        //Email Verification
        .state('shop.authentication.verifyEmail', {
            url: '/verify-email',
            data: {
                analytics: 'bws:web:email verify'
            },
            params: {
                email: null,
                password: null,
                emailMasked: null
            },
            views: {
                '@': {
                    template: loginTemplate
                },
                'login-content@shop.authentication.verifyEmail': {
                    controller: [
                        '$stateParams', '$scope', '$state', function ($stateParams, $scope, $state) {
                            if (!$stateParams.email || !$stateParams.password || !$stateParams.emailMasked) {
                                $state.go('shop.authentication.login');
                            }

                            $scope.email = $stateParams.email;
                            $scope.password = $stateParams.password;
                            $scope.emailMasked = $stateParams.emailMasked;
                        }
                    ],
                    template: '<wow-login-verify-otp email="{{::email}}" password="{{::password}}" email-masked="{{::emailMasked}}"></wow-login-verify-otp>'
                }
            }
        })
        // Mobile Number Capture
        .state('shop.authentication.mobileNumberCapture', {
            url: '/mobile-number-capture',
            data: {
                analytics: 'bws:web:mobile number capture'
            },
            params: {
                email: null,
                password: null
            },
            views: {
                '@': {
                    template: loginTemplate
                },
                'login-content@shop.authentication.mobileNumberCapture': {
                    controller: [
                        '$stateParams', '$scope', '$state', function ($stateParams, $scope, $state) {
                            if (!$stateParams.email || !$stateParams.password) {
                                $state.go('shop.authentication.login');
                            }

                            $scope.email = $stateParams.email;
                            $scope.password = $stateParams.password;
                        }
                    ],
                    template: '<wow-login-mobile-number-capture email="{{::email}}" password="{{::password}}"></wow-login-mobile-number-capture>'
                }
            }
        })
        // Mobile number verification
        .state('shop.authentication.verifyMobile', {
            url: '/verify-mobile',
            data: {
                analytics: 'bws:web:mobile verify'
            },
            params: {
                email: null,
                password: null,
                phone: null,
                phoneMasked: null
            },
            views: {
                '@': {
                    template: loginTemplate
                },
                'login-content@shop.authentication.verifyMobile': {
                    controller: [
                        '$stateParams', '$scope', '$state', function ($stateParams, $scope, $state) {
                            // phone is optional
                            if (!$stateParams.email || !$stateParams.password || !$stateParams.phoneMasked) {
                                $state.go('shop.authentication.login');
                            }

                            $scope.email = $stateParams.email;
                            $scope.password = $stateParams.password;
                            $scope.phone = $stateParams.phone;
                            $scope.phoneMasked = $stateParams.phoneMasked;
                        }
                    ],
                    template: '<wow-login-verify-otp email="{{::email}}" password="{{::password}}" phone="{{::phone}}" phone-masked="{{::phoneMasked}}"></wow-login-verify-otp>'
                }
            }
        })
        // Login Errors
        .state('shop.authentication.error', {
            url: '/login/error',
            data: {
                analytics: 'bws:web:login error'
            },
            params: {
                error: null
            },
            views: {
                '@': {
                    template: loginTemplate
                },
                'login-content@shop.authentication.error': {
                    controller: [
                        '$stateParams', '$scope', '$state', function ($stateParams, $scope, $state) {
                            if (!$stateParams.error) {
                                $state.go('shop.authentication.login');
                            }

                            $scope.error = $stateParams.error;
                        }
                    ],
                    template: '<wow-login-error error="{{::error}}"></wow-login-error>'
                }
            }
        });
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/routes/authentication.js
 **/